
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, DOCUMENT, PLATFORM_ID } from '@angular/core';

import { RouteLanguageService } from '../../services/route-language.service';
import { isPlatformBrowser } from '@angular/common';

/**
 * Footer component.
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  @Output() scrollPage = new EventEmitter<void>();
  @Input() loginUrl: string;
  @Input() signupUrl: string;

  public currentYear: number;
  public language!: string;

  constructor(
    @Inject(DOCUMENT) private document: Document, 
    @Inject(PLATFORM_ID) private platformId: Object,
    private routeLanguageService: RouteLanguageService, 
    private cd: ChangeDetectorRef,
  ) {}

  /**
   * Sets current year.
   */
  ngOnInit(): void {
    this.routeLanguageService.routeLanguage.subscribe(res => {
      this.language = res;
      this.cd.markForCheck();
    })

    this.currentYear = new Date().getFullYear();
  }

  /**
   * Scrolls to the top of the page.
   */
  public scrollPageToTop(): void {
    this.scrollPage.emit();
  }

  public goToSignup(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.document.defaultView.open(this.signupUrl, '_blank');
  }

  public goToLogin(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    
    this.document.defaultView.open(this.loginUrl, '_blank');
  }
}
